/* ============================================================
   ARTISAN DELI MARKET — THE CHROME (injector)
   One source of truth for the header, Occasions panel, mobile sheet,
   basket chip, composing bar and footer. Each page declares:
     window.CHROME = { prefix: '../', here: 'basket' }   // before this script
   prefix = path back to the site root ('' at root, '../' one level down); here = nav item.
   Reads the live basket state (adm-create-sum in progress, adm-basket-sum
   committed) so the chip tells the same truth on every page.

   THE COST OF DOING IT THIS WAY, written down so nobody rediscovers it:
   because the header, the nav and the footer are built here, the HTML a
   crawler is served contains almost no links — the raw source of every page
   is a title, one section of body copy and two empty divs. This file can't
   fix that; only a build step (or a server-side include) that writes the
   chrome into each file at publish time can, and that is the right fix
   before launch. What it CAN do is stop the injection shifting the page:
   _chrome.css reserves the header's exact height and `chrome-in` below
   releases it. Pages currently load this script last; moving the tag into
   <head> with `defer` would inject it before first paint and is worth doing
   at the same time as the build step.
   ============================================================ */
(function(){
  var C = window.CHROME || {};
  var P = C.prefix || '';               // relative path to the rebuild-plan root
  var here = C.here || '';
  /* THE ADDRESSES, in one place, and OVERRIDABLE — because this same file now
     has to serve two hosts. Standing on its own the rebuild is a static tree of
     relative paths (`../create/`); inside a Shopify theme the very same pages
     live at Shopify's own addresses (`/pages/create-your-own-hamper`), and a
     relative path there is a 404 that nothing in a test sweep would catch.
     So a host may hand its own map in — `window.CHROME.urls` — and everything
     below builds from it. No map, no change: the static tree keeps its exact
     behaviour, which is what makes this safe to land before the theme exists. */
  var U = {
    create:   P + 'create/',
    hampers:  P + 'hampers/',
    basket:   P + 'basket/',
    corporate:P + 'corporate/',
    about:    P + 'about/',
    makers:   P + 'makers/',
    home:     P || './',
    delivery: P + 'delivery/',
    faq:      P + 'faq/',
    abroad:   P + 'from-abroad/',
    returns:  P + 'returns/',
    terms:    P + 'terms/',
    privacy:  P + 'privacy/',
    /* THE FOUR POLICIES are Shopify's own pages, edited by Verity in Shopify
       admin, and the footer links those rather than a copy (Verity/Harry call
       2026-09-29, recall #3867 @28:11). Shopify serves /policies/* itself; on
       the static tree site/policies/ holds dated preview copies written by
       site/_policy_snapshot.py. A host passes the real addresses in urls. */
    shippingPolicy: P + 'policies/shipping-policy/',
    refundPolicy:   P + 'policies/refund-policy/',
    termsPolicy:    P + 'policies/terms-of-service/',
    privacyPolicy:  P + 'policies/privacy-policy/',
    account:  null,
    larderJs: P + window.ADM_ASSET("larder.js"),
    occ:      function(k){ return P + 'occasions/' + k + '/'; }
  };
  if (C.urls) {
    for (var uk in C.urls) if (Object.prototype.hasOwnProperty.call(C.urls, uk)) U[uk] = C.urls[uk];
    /* `occ` is a function everywhere else in this file, so a host that hands in
       a plain occasions prefix gets it wrapped rather than a crash on U.occ(). */
    if (typeof U.occ === 'string') { var pfx = U.occ; U.occ = function(k){ return pfx + k; }; }
  }

  /* the seven occasions + the seasonal Christmas slot */
  var OCCASIONS = [
    ['birthday',        'Birthday',        'For the one you can’t be at — or the one you can.'],
    ['thank-you',       'Thank you',       'Some thank-yous need more than a text.'],
    ['sympathy',        'Sympathy',        'When there’s nothing to say, send something kind.'],
    ['congratulations', 'Congratulations', 'They did the thing. Mark it properly.'],
    ['get-well',        'Get well',        'Something for the boring days of recovery.'],
    ['just-because',    'Just because',    'For when cheese and crisps is the whole point.']
  ];
  var mo = new Date().getMonth();                    // 0–11
  var xmasSeason = mo >= 9;                           // Oct–Dec

  /* THE SEASONS, in the menu (Verity/Harry call 2026-09-29, recall #3867).
     The homepage's season panels and the hampers page's season tabs come from
     RANGE's "seasons" tags and the season theme
     (studio/website-review/seasons/*.json). This list puts the same doors in
     Occasions while they are in season, and they open the TABS, so what a
     customer finds there is whatever is really tagged, never a promise.
     [key, name, line, first month, last month], months 0–11 inclusive.
     studio/website-review/design.py fails the build when these keys and the
     theme's sections disagree, so switching the theme cannot leave the menu
     behind. While Christmas is in season its tab replaces the Christmas lander
     in this menu (one "Christmas", not two); the lander stays in the footer
     and in search. */
  var SEASONS = [
    ['christmas', 'Christmas', 'The hamper they’ll expect again next year.', 8, 11]
  ].filter(function(s){ return mo >= s[3] && mo <= s[4]; });
  var seasonKey = SEASONS.map(function(s){ return s[0]; }).join(' ');
  function seasonHref(k){ return U.hampers + '?category=' + k; }
  if(xmasSeason && !/\bchristmas\b/.test(seasonKey)) OCCASIONS.push(['christmas','Christmas','The hamper they’ll expect again next year.']);

  /* ---------- who the shop legally is ----------
     The footer used to say "© Artisan Deli Market" and nothing else: no
     company, no registered address, no numbers — on all 21 pages. A UK
     limited company selling online has to say who it is. Name, address,
     phone and email below are verified against the live shop; the two
     numbers are NOT known here, and an empty string means the footer simply
     leaves that clause out rather than printing a placeholder. Fill them in
     HERE, once, and they appear everywhere. */
  /* The only two profiles this business has. Read off the LIVE shop's footer and
     its sameAs block 2026-08-23 — not looked up, and not guessed from the brand
     name. Adding one here that does not exist is worse than having none. */
  var SOCIAL = [
    ['Instagram', 'https://www.instagram.com/artisandelimarket'],
    ['Facebook',  'https://www.facebook.com/artisandelimarket']
  ];

  var COMPANY = {
    legal: 'Artisan Deli Market Limited',
    addr:  'Westwood Business Centre, Ditchling Common, BN6 8SG, United Kingdom',
    no:    '13546629', // Companies House, checked 8 September 2026
    vat:   'GB388376929' // Existing public store footer, checked 8 September 2026
  };

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }
  function money(x){ return '£' + Number(x).toFixed(2); }
  function possess(n){ return n + (/s$/i.test(n) ? '’' : '’s'); }
  /* THE BASKET LIVES IN localStorage (see /basket/). This used to read
     sessionStorage only, so a returning customer saw an empty chip on every
     page except the basket and the product page — no sign their basket still
     existed. localStorage first, session as the fallback for a hand-off the
     Composer has written but not yet promoted. */
  function read(k){
    if(k === 'adm-draft-20260907-basket-sum') return DeliBasketStore.summary();
    try{
      var v = localStorage.getItem(k);
      if(v == null) v = sessionStorage.getItem(k);
      return JSON.parse(v || 'null');
    }catch(e){ return null; }
  }

  var ICON_SEARCH = '<svg width="18" height="18" viewBox="0 0 19 19" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="6.4" stroke="currentColor" stroke-width="1.4"/><path d="M13 13l5 5" stroke="currentColor" stroke-width="1.4"/></svg>';
  var ICON_BASKET = '<svg width="19" height="19" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M3 6.5h14l-1.1 9.2a1.6 1.6 0 0 1-1.6 1.4H5.7a1.6 1.6 0 0 1-1.6-1.4L3 6.5Z" stroke="currentColor" stroke-width="1.3"/><path d="M7 6.5a3 3 0 0 1 6 0" stroke="currentColor" stroke-width="1.3"/></svg>';
  var ICON_CARET = '<svg class="caret" width="11" height="7" viewBox="0 0 11 7" fill="none" aria-hidden="true"><path d="M1 1.2l4.5 4.3L10 1.2" stroke="currentColor" stroke-width="1.5"/></svg>';

  /* ---------- header markup ---------- */
  function navLink(id, href, label, cls){
    return '<a class="hlink ' + (cls||'') + (here===id?' is-here':'') + '" href="' + href + '">' + label + '</a>';
  }
  var occListHTML = OCCASIONS.map(function(o){
    return '<a class="occ-item" href="' + U.occ(o[0]) + '"><span class="oname">' + esc(o[1])
      + '<span class="oc-arrow" aria-hidden="true">→</span></span><span class="oreg">' + esc(o[2]) + '</span></a>';
  }).join('');
  var featureHTML = SEASONS.length
    ? '<div class="occ-feature occ-feature--season"><div class="oft-k">In season</div><div class="oft-h">'
      + esc(SEASONS.map(function(s){ return s[1]; }).join(' and ')) + ', composed.</div>'
      + SEASONS.map(function(s){ return '<a class="oft-l" href="' + seasonHref(s[0]) + '">' + esc(s[1]) + ' hampers →</a>'; }).join('')
      + '</div>'
    : xmasSeason
    ? '<div class="occ-feature"><div class="oft-k">In season</div><div class="oft-h">The Christmas table, composed.</div><a class="oft-l" href="' + U.occ('christmas') + '">Start a Christmas hamper →</a></div>'
    : '<div class="occ-feature"><div class="oft-k">This week</div><div class="oft-h">A thank-you they’ll remember.</div><a class="oft-l" href="' + U.occ('thank-you') + '">See thank-you hampers →</a></div>';

  var headerHTML =
    '<a class="skip" href="#main">Skip to content</a>'
  + '<header class="hdr" id="site-hdr" data-season="' + seasonKey + '">'
  +   '<div class="hdr-in">'
  +     '<button class="hburger" id="ch-burger" aria-label="Menu" aria-expanded="false"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" stroke-width="1.5"/></svg></button>'
  +     '<nav class="hnav left" aria-label="Primary">'
  +       navLink('create', U.create, 'Create a Hamper', 'hlink--create')
  +       navLink('hampers', U.hampers, 'Hampers')
  +       '<button class="hlink' + (here==='occasions'?' is-here':'') + '" id="ch-occ-btn" aria-expanded="false" aria-controls="ch-occ">Occasions' + ICON_CARET + '</button>'
  +     '</nav>'
  +     '<a class="wordmark" href="' + U.home + '">Artisan<b>·</b>Deli<b>·</b>Market</a>'
  +     '<nav class="hnav right" aria-label="Secondary">'
  +       navLink('corporate', U.corporate, 'Corporate')
  +       navLink('about', U.about, 'About')
  +       '<button class="hicon" id="ch-search" aria-label="Search">' + ICON_SEARCH + '</button>'
  /* the second basket. While a hamper is being composed the chip below turns
     into "Continue composing" and points at /create/ — which left a desktop
     customer with paid-for hampers already in the basket no way to reach it
     from anywhere in the chrome. This one appears only in that situation: a
     composition in progress AND something committed waiting. */
  +       '<a class="hbasket hbasket-alt" id="ch-basket-alt" href="' + U.basket + '" aria-label="Basket"><span class="hb-ico">' + ICON_BASKET + '</span><span class="hb-n num"></span></a>'
  +       '<a class="hbasket" id="ch-basket" href="' + U.basket + '" aria-label="Basket"><span class="hb-ico">' + ICON_BASKET + '</span></a>'
  +     '</nav>'
  +     '<a class="hbasket hbasket-m" id="ch-basket-m" href="' + U.basket + '" aria-label="Basket"><span class="hb-ico">' + ICON_BASKET + '</span></a>'
  +   '</div>'
  +   '<div class="occpanel" id="ch-occ" role="region" aria-label="Occasions">'
  +     '<div class="occpanel-in">'
  +       '<div class="occ-list">' + occListHTML + '</div>'
  +       '<div class="occ-aside">'
  +         '<span class="t-label">Or by budget</span>'
  +         '<div class="occ-budget">'
  +           '<a href="' + U.hampers + '?to=60">Up to £60<span class="ob-sub">the thoughtful start</span></a>'
  +           '<a href="' + U.hampers + '?to=100">Up to £100<span class="ob-sub">a proper evening</span></a>'
  +           '<a href="' + U.hampers + '?to=175">Up to £175<span class="ob-sub">the generous one</span></a>'
  +           '<a href="' + U.hampers + '?flagship=1">The Wicker Collection<span class="ob-sub">gifts in a keepsake basket</span></a>'
  +         '</div>'
  +         featureHTML
  +       '</div>'
  +     '</div>'
  +   '</div>'
  + '</header>';

  /* ---------- mobile sheet ---------- */
  var sheetOccHTML = SEASONS.map(function(s){
    return '<a class="sheet-season" href="' + seasonHref(s[0]) + '">' + esc(s[1]) + ' hampers<span class="oreg">' + esc(s[2]) + '</span></a>';
  }).join('') + OCCASIONS.map(function(o){
    return '<a href="' + U.occ(o[0]) + '">' + esc(o[1]) + '<span class="oreg">' + esc(o[2]) + '</span></a>';
  }).join('');
  var sheetHTML =
    '<div class="sheet" id="ch-sheet" role="dialog" aria-modal="true" aria-label="Menu" aria-hidden="true">'
  +   '<div class="sheet-top"><a class="wordmark" href="' + U.home + '">Artisan<b>·</b>Deli<b>·</b>Market</a>'
  +     '<button class="hicon" id="ch-sheet-close" aria-label="Close"><svg width="20" height="20" viewBox="0 0 20 20"><path d="M3 3l14 14M17 3L3 17" stroke="currentColor" stroke-width="1.5"/></svg></button></div>'
  +   '<div class="sheet-body">'
  +     '<a class="btn" href="' + U.create + '">Create a Hamper</a>'
  +     '<nav class="sheet-nav" aria-label="Menu">'
  +       '<a href="' + U.hampers + '">Hampers</a>'
  /* `inert` on the collapsed sub, not just max-height:0. The accordion is shut
     on open, and its six occasion links were still in the tab order — a
     keyboard user tabbed through six things they could not see, in a panel
     they had not opened. CSS visibility does the same job for browsers without
     inert (see .sheet-sub in _chrome.css); both are toggled together below. */
  +       '<div class="sheet-acc" id="ch-sheet-occ"><button type="button" aria-expanded="false">Occasions' + ICON_CARET + '</button>'
  +         '<div class="sheet-sub" inert>' + sheetOccHTML + '</div></div>'
  +       '<a href="' + U.corporate + '">Corporate</a>'
  +       '<a href="' + U.about + '">About</a>'
  +     '</nav>'
  +     '<label class="sheet-search">' + ICON_SEARCH + '<input type="search" placeholder="Cheese, port, ‘for Dad’…" aria-label="Search"></label>'
  +     '<div class="sheet-foot">'
  +       '<span class="sf-rate">Rated <b>4.8</b> on Trustpilot, from over 1,400 reviews</span></div>'
  +   '</div>'
  + '</div>';

  /* ---------- search ----------
     The magnifier used to be a button that did nothing on every page it
     appeared on. Then it opened a panel whose only move was to hand the words
     to /hampers/?q= — better, but it still implied a site search while
     indexing nothing at all: type "delivery" and you got no hampers and no
     delivery page. It now searches real content as you type — this site's own
     pages, and the larder shelf itself (every curated item, with its live
     price) — and Enter still runs the words through the hampers, which match
     on their contents. Nothing here is a promise the panel can't keep. */

  /* Every page of the site, with a plain line about what is on it. Kept by
     hand because there is no build step: if you add a page, add it here. */
  var PAGES = [
    ['Create a Hamper',   U.create,          'Compose one, from the box to the note.'],
    ['Hampers',           U.hampers,         'The ready-made range.'],
    ['Corporate gifting', U.corporate,       'Gifting from a business.'],
    ['The makers',        U.makers,          'The people who make the food.'],
    ['About',             U.about,           'Who we are.'],
    ['Delivery',          U.delivery,        'Rates, dates and cut-offs.'],
    ['FAQs',              U.faq,             'The questions we are asked.'],
    ['From abroad',       U.abroad,          'Sending into the UK from outside it.'],
    ['Shipping policy',   U.shippingPolicy,  'Delivery rates, remote postcodes and missed deliveries.'],
    ['Refund policy',     U.refundPolicy,    'Returns, and if something arrives wrong.'],
    ['Terms of service',  U.termsPolicy,     'The terms of sale.'],
    ['Privacy policy',    U.privacyPolicy,   'What happens to your details.'],
    ['Basket',            U.basket,          'What you have put together so far.']
  ].concat(OCCASIONS.map(function(o){ return [o[1], U.occ(o[0]), o[2]]; }));
  /* the Christmas lander exists all year — it just isn't in the menu until October */
  if(!OCCASIONS.some(function(o){ return o[0] === 'christmas'; })) PAGES.push(['Christmas', U.occ('christmas'), 'The hamper they’ll expect again next year.']);
  SEASONS.forEach(function(s){ PAGES.push([s[1] + ' hampers', seasonHref(s[0]), s[2]]); });

  var searchHTML =
    '<div class="srch" id="ch-srch" role="dialog" aria-modal="true" aria-label="Search" aria-hidden="true">'
  +   '<form class="srch-in" id="ch-srch-form" role="search">'
  +     '<label class="srch-field">' + ICON_SEARCH
  +       '<input type="search" id="ch-srch-q" autocomplete="off" placeholder="Cheese, port, ‘for Dad’…" aria-label="Search the hampers, the larder and this site" aria-describedby="ch-srch-scope">'
  +     '</label>'
  +     '<button type="button" class="srch-x" id="ch-srch-x" aria-label="Close search">Close</button>'
  +     '<div class="srch-res" id="ch-srch-res" role="region" aria-label="Search results" aria-live="polite" hidden></div>'
  +     '<p class="srch-scope" id="ch-srch-scope">We search the larder shelf and the pages of this site as you type. Enter looks through the hampers, contents and all.</p>'
  +     '<div class="srch-doors">'
  +       '<span class="t-label">Or start here</span>'
  +       '<a href="' + U.create + '">Create a Hamper</a>'
  +       '<a href="' + U.hampers + '">Every hamper</a>'
  +       '<a href="' + U.occ('birthday') + '">Birthday</a>'
  +       '<a href="' + U.hampers + '?to=60">Up to £60</a>'
  +       '<a href="' + U.hampers + '?flagship=1">The Wicker Collection</a>'
  +     '</div>'
  +   '</form>'
  + '</div>';

  /* ---------- footer ---------- */
  /* The signup box is GONE, deliberately. It took an address, hid itself and
     said "Noted. We'll write when there's something worth saying." — while
     capturing nothing at all: there is no list connected (the deli's own
     Klaviyo account isn't wired up yet). That is a lie told on 21 pages to
     every person who volunteers an email. The letter is still the plan, so
     the block stays and says where it has actually got to. Put the form back
     the day the list exists, not before. */
  var footerHTML =
    '<footer class="foot">'
  +   '<div class="foot-in">'
  +     '<div class="foot-news">'
  +       '<div><h2>Join our mailing list.</h2>'
  +         '<p class="fn-note">New hampers, makers we’ve found, and when to order for Christmas.</p></div>'
  +       '<div class="fn-form">'
  /* ⚠️ THIS PARAGRAPH USED TO SAY "no list… we aren't collecting addresses for
     one", and on the SHOP that is not true: Klaviyo's onsite embed is live,
     static-forms.klaviyo.com loads on every page, and its popup is what writes
     the discount codes. Measured 2026-08-23. The letter genuinely has not
     started, so that half is kept — but a footer on 45 pages may not tell a
     customer we collect nothing while a popup in front of it asks for their
     address. See the privacy page, which now says the same thing at length. */
  +         '<p class="fn-soon">Leave your email in the box that pops up, or at the checkout, and you’re on it.</p>'
  +         '<p class="fn-soon fn-soon--alt">Any questions? <a href="mailto:hello@artisandelimarket.co.uk">hello@artisandelimarket.co.uk</a> and <a href="tel:+441273102712">01273 102712</a> both reach us.</p>'
  +       '</div>'
  +     '</div>'
  +     '<div class="foot-cols">'
  +       '<div class="foot-col"><div class="fc-mark">Artisan<b>·</b>Deli<b>·</b>Market</div>'
  +         '<p>Hand-packed at Ditchling Common, Sussex.</p><p>hello@artisandelimarket.co.uk</p></div>'
  +       '<div class="foot-col"><h3>Shop</h3>'
  /* NO gift-cards link: gift cards are OUT for launch (Harry, 2026-07-25) — the
     site ships without one until we build our own. The designed page is parked
     at /_gift-cards/ so the work isn't lost. Don't relink it. */
  +         '<a href="' + U.create + '">Create a Hamper</a><a href="' + U.hampers + '">Hampers</a><a href="' + U.occ('christmas') + '">Christmas</a><a href="' + U.corporate + '">Corporate gifting</a></div>'
  +       '<div class="foot-col"><h3>Occasions</h3>'
  +         OCCASIONS.slice(0,6).map(function(o){ return '<a href="' + U.occ(o[0]) + '">' + esc(o[1]) + '</a>'; }).join('') + '</div>'
  +       '<div class="foot-col"><h3>Help</h3>'
  +         '<a href="' + U.delivery + '">Delivery</a><a href="' + U.faq + '">FAQs</a><a href="' + U.abroad + '">From abroad</a><a href="' + U.about + '">About</a><a href="' + U.makers + '">The makers</a>'
  +         (U.account ? '<a href="' + U.account + '">Your account and orders</a>' : '') + '</div>'
  +     '</div>'
  +     '<div class="foot-base">'
  +       '<div class="fb-commit">Composed in Sussex.</div>'
  /* real pages, not href="#". All three were dead links on every page of the
     site, and _qa.mjs filtered `^#` out of its link check so it never noticed.
     They are the four Shopify policies Verity edits, not the site's own copies
     (call 2026-09-29): see U above and site/_POLICIES.md. */
  +       '<div class="fb-legal"><a href="' + U.shippingPolicy + '">Shipping policy</a><a href="' + U.refundPolicy + '">Refund policy</a>'
  +         '<a href="' + U.termsPolicy + '">Terms of service</a><a href="' + U.privacyPolicy + '">Privacy policy</a></div>'
  /* SOCIAL — the two the shop actually has, and only those. The live footer
     links both and both are in the live shop's sameAs structured data, so a
     rebuild that dropped them would have quietly cost the brand its only two
     verified profiles on switch day. Measured 2026-08-23; see _FACTS.md.
     rel=me is what makes sameAs and the profile agree in both directions. */
  +       '<div class="fb-social">'
  +         SOCIAL.map(function(s){
              return '<a href="' + s[1] + '" rel="me noopener" target="_blank" aria-label="'
                   + esc(COMPANY.legal) + ' on ' + esc(s[0]) + '">' + esc(s[0]) + '</a>';
            }).join('')
  +       '</div>'
  /* the identity line: who you are actually buying from, and where they are.
     Numbers appear only once COMPANY carries them — never a placeholder. */
  +       '<div class="fb-co">© ' + new Date().getFullYear() + ' ' + esc(COMPANY.legal)
  /* the address is the one the shop itself gives, not (verified) the
     registered office — so it is stated plainly, without that label */
  +         ' · ' + esc(COMPANY.addr)
  +         (COMPANY.no  ? ' · Company no. ' + esc(COMPANY.no)  : '')
  +         (COMPANY.vat ? ' · VAT no. ' + esc(COMPANY.vat) : '')
  +       '</div>'
  +     '</div>'
  +   '</div>'
  + '</footer>';

  /* ---------- inject ----------
     The pages load this script at the END of the body, so for one frame every
     page renders with no header at all and then ~126px of header drops in and
     shoves the whole document down — a layout shift on every page of the site.
     _chrome.css reserves that height up front (html:not(.chrome-in) body) and
     the class below hands it straight back, in the same frame as the markup,
     so the header fills a space that was already there. Set it FIRST: an
     exception anywhere below would otherwise leave the gap standing. */
  var head = document.getElementById('site-header');
  var foot = document.getElementById('site-footer');
  document.documentElement.classList.add('chrome-in');

  /* ...and since 27 July the markup is usually ALREADY THERE. `node _bake.mjs`
     runs this very file in a real browser and writes what it produced back into
     each page, so a crawler — and anyone with scripts off — gets a real header
     and footer instead of two empty divs. That is one SOURCE, still: nothing is
     re-typed, the bake only records this file's own output. When the baked
     markup is present and current we leave it exactly alone and go straight to
     wiring the behaviour, which is also what finally removes the chrome's
     layout shift: the header is in the first paint rather than a frame later.

     TWO THINGS GO STALE ON A CALENDAR: Christmas joins the Occasions menu in
     October, and the footer prints the year. Both are in the signature, so if
     the clock has moved past what was baked we simply re-render and the page is
     right anyway. The bake is an optimisation; it is never the only path. */
  var sig = (mo >= 9 ? 'x' : 'n') + new Date().getFullYear();
  /* 🚨 AND THE SIGNATURE IS A CALENDAR, NOT A CHECKSUM — which is why the bake
     needs a way to say "ignore what is already there". Measured 2026-08-23: a
     real change to this file (the footer's social links) baked to 0 pages and
     reported `every page current`, because every page's slot still carried a
     signature that had not moved. The bake ran a browser, the browser saw baked
     markup, left it alone, and handed the same bytes straight back. So any edit
     to the chrome silently does not ship until the season or the year turns.
     `node _bake.mjs` now sets window.ADM_REBAKE before this file runs. */
  /* The seasons move on their own calendar, which the signature above cannot
     see (Halloween leaves the menu in November, inside one "x" signature). So
     the header records which seasons it was baked with, and a baked header
     that disagrees with today's is re-rendered like any other stale bake. */
  var bakedHdr = head && head.querySelector('#site-hdr');
  var bakedHead = !window.ADM_REBAKE && head && head.getAttribute('data-baked') === sig && head.firstElementChild
    && bakedHdr && (bakedHdr.getAttribute('data-season') || '') === seasonKey;
  var bakedFoot = !window.ADM_REBAKE && foot && foot.getAttribute('data-baked') === sig && foot.firstElementChild;

  if(head && !bakedHead) head.innerHTML = headerHTML + sheetHTML + searchHTML
    + '<div class="chrome-scrim" id="ch-scrim"></div>'
    + '<a class="compbar" id="ch-compbar" href="' + U.create + '"><span class="cb-l" id="ch-compbar-l"></span><span class="cb-go" id="ch-compbar-go">Continue →</span></a>';
  if(foot && !bakedFoot) foot.innerHTML = footerHTML;

  // The composer has its own header. Shopify still loads this shared module;
  // there are no shared menu/search controls to wire on that template.
  if(!head){ window.ADMChrome = {paintChip:paintChip}; return; }

  /* ---------- behaviour ---------- */
  var hdr = document.getElementById('site-hdr');
  var occBtn = document.getElementById('ch-occ-btn');
  var occPanel = document.getElementById('ch-occ');
  var scrim = document.getElementById('ch-scrim');
  var sheet = document.getElementById('ch-sheet');
  var burger = document.getElementById('ch-burger');

  /* condense on scroll */
  function onScroll(){ if(hdr) hdr.classList.toggle('tight', scrollY > 40); }
  addEventListener('scroll', onScroll, {passive:true}); onScroll();

  /* ---------- one focus trap, two overlays ----------
     Both the sheet and the search are role="dialog" aria-modal="true" and both
     cover the page. aria-modal tells a screen reader nothing outside exists —
     so Tab must not be able to reach outside either, or the promise is a lie.
     The sheet had a trap of its own and the search had none at all: opening it
     and pressing Tab thirty times put focus outside the dialog twenty-four
     times, walking the whole footer behind the scrim. This is that one trap.

     The visibility filter is load-bearing. The sheet's collapsed Occasions sub
     holds six links that are present but unreachable, and a trap that thinks
     one of them is the "last" element dead-ends on Tab at a control nobody can
     see. Only what is really focusable counts. */
  var FOCUS_SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function focusables(box){
    return [].filter.call(box.querySelectorAll(FOCUS_SEL), function(el){
      if(el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;
      if(el.closest && el.closest('[inert]')) return false;
      if(!el.getClientRects().length) return false;              // display:none, or a closed panel
      return getComputedStyle(el).visibility !== 'hidden';
    });
  }
  function trapTab(box, isOpen){
    /* on the DOCUMENT, not on the box. The box only hears a keystroke once
       focus is already inside it, so any moment where the overlay is open and
       focus has not landed yet is a moment the trap cannot see — one Tab there
       and the search dialog handed you A#ch-basket, outside itself. focusIn
       below makes that window nil; listening at document level makes it
       harmless even if it ever reopens. isOpen() is the whole guard: while an
       overlay is open it is the only thing on the screen. */
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Tab' || !isOpen()) return;
      var f = focusables(box);
      if(!f.length) return;
      var i = f.indexOf(document.activeElement);
      /* focus sitting on the dialog itself, or on a control that has since been
         hidden (the results list re-renders as you type) — put it back inside
         rather than let the next Tab leave */
      if(i === -1){ e.preventDefault(); f[0].focus(); return; }
      if(e.shiftKey && i === 0){ e.preventDefault(); f[f.length - 1].focus(); }
      else if(!e.shiftKey && i === f.length - 1){ e.preventDefault(); f[0].focus(); }
    });
  }

  /* ---------- focus something that has JUST been un-hidden ----------
     Every overlay here is hidden with `visibility:hidden`, and .focus() on a
     descendant of anything computing visibility:hidden is a silent no-op. The
     three openers each papered over that with a timer — 0ms for the Occasions
     panel, 60ms for the search — and timers are not a fix, they are a race that
     usually wins. Under `prefers-reduced-motion:reduce` it lost every time (see
     the long note in _chrome.css: transition-property:all plus a forced
     duration means an overlay's contents inherit `hidden` for a frame after it
     opens), and even when it won, the 60ms gap was a hole in the search
     dialog's own trap: a Tab pressed inside it walked out to the basket.

     So: try it now, and only if the element genuinely refused it wait for
     frames rather than milliseconds. The CSS above means the synchronous call
     is the one that lands; the retry is the belt, bounded so a control that can
     never take focus doesn't spin. */
  function focusIn(el){
    if(!el) return;
    el.focus();
    var tries = 0;
    (function retry(){
      if(document.activeElement === el || ++tries > 8) return;
      requestAnimationFrame(function(){ el.focus(); retry(); });
    })();
  }

  /* occasions dropdown */
  var occOpen = false, occOpenedAt = 0;
  function setOcc(v){
    occOpen = v;
    if(v) occOpenedAt = Date.now();
    occPanel.classList.toggle('open', v);
    occBtn.setAttribute('aria-expanded', v);
    scrim.classList.toggle('open', v);
  }
  if(occBtn){
    occBtn.addEventListener('click', function(e){
      e.stopPropagation();
      /* hover already opened it a heartbeat ago — the click that FOLLOWS a
         hover means "yes, this one", not "close it again". Without this guard
         pointing at Occasions and clicking shuts the panel you just opened. */
      if(occOpen && Date.now() - occOpenedAt < 400) return;
      setOcc(!occOpen);
    });
    occPanel.addEventListener('click', function(e){ e.stopPropagation(); });
    document.addEventListener('click', function(){ if(occOpen) setOcc(false); });
    addEventListener('scroll', function(){ if(occOpen) setOcc(false); }, {passive:true});
    addEventListener('keydown', function(e){ if(e.key==='Escape' && occOpen){ setOcc(false); occBtn.focus(); } });

    /* hover-intent: a pointer that pauses on the word wants the panel; one
       merely crossing it does not. Closes on leaving the whole header, not the
       button, so the diagonal trip down to the first occasion never drops it. */
    var hoverT;
    if(matchMedia('(hover:hover)').matches){
      occBtn.addEventListener('mouseenter', function(){
        hoverT = setTimeout(function(){ setOcc(true); }, 90);
      });
      occBtn.addEventListener('mouseleave', function(){ clearTimeout(hoverT); });
      hdr.addEventListener('mouseleave', function(){ clearTimeout(hoverT); if(occOpen) setOcc(false); });
    }

    /* keyboard: Down/Enter/Space opens and lands focus on the first occasion, so
       the panel is reachable without a mouse.

       All three preventDefault, and that matters. Space used to scroll the page,
       and the scroll listener two lines up closes the panel — so Space opened
       and shut it inside one keystroke. Enter and Space also used to be left to
       the click the browser synthesises, which fires AFTER this handler: the
       panel was still shut when we looked for somewhere to put focus, so focus
       stayed on the button and Tab walked off into the wordmark and the
       secondary nav — five stops before the panel it had just opened, because
       .occpanel comes after .hdr-in in the DOM. */
    occBtn.addEventListener('keydown', function(e){
      if(e.key !== 'ArrowDown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      if(occOpen && e.key !== 'ArrowDown'){ setOcc(false); return; }   // Enter/Space toggles
      setOcc(true);
      focusIn(occPanel.querySelector('.occ-item'));
    });
    /* and back out the way you came in: Shift+Tab off the first occasion returns
       to the button that opened the panel, rather than the basket icon that
       happens to precede the panel in source order */
    occPanel.addEventListener('keydown', function(e){
      if(e.key !== 'Tab' || !e.shiftKey || !occOpen) return;
      var f = focusables(occPanel);
      if(f.length && document.activeElement === f[0]){ e.preventDefault(); setOcc(false); occBtn.focus(); }
    });
    occPanel.addEventListener('focusout', function(){
      setTimeout(function(){
        if(!occOpen) return;
        var to = document.activeElement;
        if(to && (occPanel.contains(to) || to === occBtn)) return;
        setOcc(false);
      }, 0);
    });
  }

  /* mobile sheet.
     `quiet` skips the focus return, for the one caller that is handing focus
     somewhere better: the sheet's search field opens the search overlay, and
     bouncing focus off the burger on the way there is a flicker nobody needs. */
  function setSheet(v, quiet){
    sheet.classList.toggle('open', v);
    sheet.setAttribute('aria-hidden', !v);
    if(burger) burger.setAttribute('aria-expanded', v);
    document.body.style.overflow = v ? 'hidden' : '';
    if(v){ scrim.classList.remove('open'); focusIn(document.getElementById('ch-sheet-close')); }
    else if(burger && !quiet){ burger.focus(); }
  }
  /* trap Tab within the open sheet — keyboard users can't fall out behind the overlay */
  trapTab(sheet, function(){ return sheet.classList.contains('open'); });
  if(burger) burger.addEventListener('click', function(){ setSheet(true); });
  var sheetClose = document.getElementById('ch-sheet-close');
  if(sheetClose) sheetClose.addEventListener('click', function(){ setSheet(false); });
  var sheetOcc = document.getElementById('ch-sheet-occ');
  if(sheetOcc) sheetOcc.querySelector('button').addEventListener('click', function(){
    var open = sheetOcc.classList.toggle('open');
    this.setAttribute('aria-expanded', open);
    /* the sub is inert while it is shut, so its six links leave the tab order
       with it. CSS visibility says the same thing for the transition and for
       browsers without inert; this is the half that is instant. */
    var sub = sheetOcc.querySelector('.sheet-sub');
    if(sub && sub.toggleAttribute) sub.toggleAttribute('inert', !open);
  });
  addEventListener('keydown', function(e){ if(e.key==='Escape' && sheet.classList.contains('open')) setSheet(false); });

  /* search behaviour — the mobile sheet's field opens the same panel, so there
     is one search on the site rather than two that behave differently */
  var srch = document.getElementById('ch-srch');
  var srchQ = document.getElementById('ch-srch-q');
  /* who opened it. An aria-modal dialog that closes and drops focus on <body>
     leaves a keyboard user at the top of the document with no idea where they
     are — they have to tab the whole page back to the magnifier they pressed.
     Escape, Close and a click on the scrim all hand focus back to the opener. */
  var srchReturn = null;
  function setSrch(v, opener){
    srch.classList.toggle('open', v);
    srch.setAttribute('aria-hidden', !v);
    document.body.style.overflow = v ? 'hidden' : '';
    if(v){
      srchReturn = opener || document.activeElement;
      if(occOpen) setOcc(false);
      focusIn(srchQ);                   // synchronously — never on a timer, see focusIn
      ensureLarder(renderRes);          // the shelf arrives on first open, not on page load
    } else if(srchReturn){
      var back = srchReturn; srchReturn = null;
      /* only if it is still on the page and still visible — the sheet's field
         opens this panel and is gone by the time it closes */
      if(back.isConnected && back.getClientRects().length) back.focus();
    }
  }
  trapTab(srch, function(){ return srch.classList.contains('open'); });
  var srchBtn = document.getElementById('ch-search');
  if(srchBtn) srchBtn.addEventListener('click', function(){ setSrch(true, srchBtn); });
  var srchX = document.getElementById('ch-srch-x');
  if(srchX) srchX.addEventListener('click', function(){ setSrch(false); });
  srch.addEventListener('click', function(e){ if(e.target === srch) setSrch(false); });
  addEventListener('keydown', function(e){ if(e.key==='Escape' && srch.classList.contains('open')) setSrch(false); });
  document.getElementById('ch-srch-form').addEventListener('submit', function(e){
    e.preventDefault();
    var q = srchQ.value.trim();
    /* Enter always lands somewhere: the hampers page filters on the whole
       record (contents, makers, vessel), and when nothing matches IT hands the
       words on to the larder. An empty box just opens the range. */
    location.href = U.hampers + (q ? '?q=' + encodeURIComponent(q) : '');
  });

  /* ---- what the search actually searches ----
     The shelf lives in create/_larder.js — 110KB of real product data with
     live prices. Far too much to load on every page for a panel most people
     never open, so it is fetched the first time the search opens and never
     again. If it fails to arrive the panel still searches the site's pages
     and Enter still works; nothing here is load-bearing for the page. */
  var srchRes = document.getElementById('ch-srch-res');
  var larderAsked = false;
  function ensureLarder(then){
    if(larderAsked || typeof LARDER !== 'undefined'){ then(); return; }
    larderAsked = true;
    var s = document.createElement('script');
    s.src = U.larderJs;
    s.onload = then; s.onerror = then;
    document.head.appendChild(s);
  }
  function aisleOf(a){
    try { return (typeof AISLES !== 'undefined' && AISLES[a]) ? AISLES[a].name : ''; } catch(e){ return ''; }
  }

  PAGES = PAGES.concat([["The Cheeseboard", "/hampers/the-cheeseboard/", "£60 · Black Bomber Cheddar, Organic Cotswold Brie, Blue Stilton, Basil & Olive Oil Crackers, Cheeseboard Chutney, Fig & Almond Cake, Empeltre Black Olives"], ["The Plant-Based Pantry", "/hampers/the-plant-based-pantry/", "£60 · Lentil & Bean Pâté, Basil & Olive Oil Crackers, Cherry Peppers with Humous, Empeltre Black Olives, Chilli & Lime Cashews & Peanuts, Traditional Olive Oil Tortas, 70% Organic Dark Chocolate, Lemon Olive Oil"], ["The Craft Beer Box", "/hampers/the-craft-beer-box/", "£65 · Deckchair Cruiser Lagerbier, Juicy Buoy IPA, Fruit Machine IPA, Spicy Chorizo Hoop, Spicy Snackalami, Black Truffle Crisps, Chilli & Lime Cashews & Peanuts, Gouda Cheese Melt Bites, Snacking Pickles"], ["The Friday Night In", "/hampers/the-friday-night-in/", "£85 · Muriel Crianza Rioja, Black Bomber Cheddar, Organic Cotswold Brie, Wild Garlic Salami, Fig, Honey & Olive Oil Crackers, Fig & Apple Chutney, Six Mix Olives, Fruit & Nut Milk Chocolate"], ["The Sharing Table", "/hampers/the-sharing-table/", "£125 · Black Bomber Cheddar, Organic Cotswold Brie, Organic Manchego, Spanish Charcuterie Selection, Traditional Pork Rillette, Basil & Olive Oil Crackers, Dates, Hazelnuts & Pumpkin Seeds Toast, Cheeseboard Chutney, Cherry Peppers with Ricotta & Capers, Empeltre Black Olives, Irresistibili Cantucci, Assorted Belgian Chocolates"], ["The Harvest Supper", "/hampers/the-harvest-supper/", "£130 · Malbec 2021, Carboncino, Red Leicester, Cacao Spiced Venison Bresaola, Asturian Chorizo, Morcilla & Pancetta Selection, Mushroom Pâté with Chilli & Coriander, Hot Garlic Chutney, Rye Sourdough Crackers, Smoky Paprika Crisps"], ["The Christmas Eve", "/hampers/the-christmas-eve/", "£80 · Prosecco Brut, Blue Stilton, Cranberry Cheddar Barrel, Duck Rillette with Cranberries & Grand Marnier, Chicken Liver Pâté with Port, Pear, Date & Cognac Chutney, Rosemary & Extra Virgin Olive Oil Crackers, Classic Fruit Cake"], ["The Christmas Table", "/hampers/the-christmas-table/", "£230 · Brut NV English Sparkling Wine, Primitivo, Sussex Charmer Mature, Organic Seven Sisters Cheese, Duck Liver Pâté with Cointreau, Ibérico Bellota Chorizo, Dottato Figs for Cheese, Savoury Ship’s Butter Crackers, Cranberry & Rolled Oat Crumbles, Cherry & Almond Loaf Cake, Milk Chocolate Irish Cream Truffles, Classic Butter Fudge in Tin, Marcona Almonds with Milk Chocolate & Praline"], ["The Cheese & Charcuterie Lovers", "/hampers/the-cheese-and-charcuterie-lovers/", "£85 · Sea Salt & Pepper Savoury Wafers, Sea Salt Crisps, Spicy Snackalami, Traditional Pork Rillette, Whole Camembert, Smoked Cheddar Barrel, Hot Honey, Air-dried Pork Loin Lomo, Wild Garlic Salami, Jalapeño Pork Crackling"], ["Cheese, Chorizo & Wine", "/hampers/the-cheese-chorizo-and-wine/", "£65 · Tempranillo Tinto, Just Jane Mature Cheddar, Garden Herbs & Garlic Cheddar Barrel, Whole Camembert, 70% Organic Dark Chocolate, Spicy Chorizo Hoop, Chilli & Garlic Seeded Flatbread Crackers"], ["The Ploughman’s Tray", "/hampers/the-ploughmans-tray/", "£40 · Beach Session IPA 4%, Fuzz Lightyear Peach Radler 2.8%, English Mustard Pork Crackling, Salt & Vinegar Pork Crackling, Ham & Mustard Crisps, Salt Crust Peanuts, Cheddar Cheese Straws, Pickle Power Pickled Onion Cheddar, Cocktail Gherkins, Balsamic Caramelised Onion Chutney"], ["Cheese, Olives & Wine", "/hampers/the-cheese-olives-and-wine/", "£45 · Santiago Merlot, Spicy Pitted Gordal Olives, Six Mix Olives, Finest Vintage English Cheddar, Classic Olive Oil Crackers"], ["Cheese, Crackers & Chutney", "/hampers/the-cheese-crackers-and-chutney/", "£35 · Caramelised Onion Cheddar, Garlic & Chive Cheddar, Smoked Cheddar Barrel, Savoury Ship’s Butter Crackers, Fig & Apple Chutney"], ["The Christmas Cheeseboard", "/hampers/the-christmas-cheeseboard/", "£80 · Malbec 2021, Picos Blue, English Farmhouse Goat Cheddar, Organic Cotswold Brie, Balsamic Caramelised Onion Chutney, Savoury Ship's Olive Oil Crackers, Panforte Fig & Walnut, Dark Chocolate Dipped Figs"], ["The Sweet Tooth", "/hampers/the-sweet-tooth/", "£75 · Cocoa Dusted Salted Toffee Truffles, Pistachio Cremino Chocolate Bar, Sea Salted Caramel Fudge Trio, Pistachio Shortbread Rounds, Caramel Shortbread, Chocolate Covered Cantucci, Milk Chocolate Original Mini Delights, Amaretti, Soft Almond Macaroons"], ["A Mediterranean Christmas", "/hampers/a-mediterranean-christmas/", "£210 · Viura Blanco, Classic Baby Panettone, Panforte Nero, Soft Turrón, Ricciarelli di Siena, Soft Almond Cookies, Cantucci al Cioccolato, Señorío 75% Ibérico Bellota Ham, Charcuterie Selection Platter, Organic Manchego, Carboncino, Natural Honeycomb, Artichoke Hearts from Puglia, Olives Stuffed with Sundried Tomato, Flaked Salt Olive Oil Crackers"]]);
  PAGES = PAGES.concat([["The Banquet Hamper", "https://www.artisandelimarket.co.uk/products/the-banquet-hamper", "£145 · Garlic and Chive Cheese 200g Wax Truckle, Smoked Cheddar Cheese Barrel 145g, Whole Camembert 250g, Mushroom Pâté 125g, Benetto Dark Mint Bar 80g, Bennetto Dark Chocolate Bar with Coconut Flakes 80g, British Charcuterie Sharing Board 60g, Cheeseboard Chutney 225g, Strawberries & Cream Fudge Trio Slider 63g, Tomato & Basil Seeded Flatbread Crackers 130g, Baked Sweet Chilli Peanuts and Cashews 90g, Snackalami ‘Spicy’ 30g, Sea Salt Kent Crisps 40g, Pictorial Viognier, 75cl, Santiago Merlot, 75cl"]]);
  PAGES = PAGES.concat([["Artisan Goody Hamper", "https://www.artisandelimarket.co.uk/products/artisan-goody-hamper", "£55 · Black Truffle Crisps 40g, Crispy Wafer Rolls with Cocoa Cream 150g, Ever-So-English Breakfast Tea, Gouda Cheese Melt Bites 75g, Sea Salted Caramel Biscuits 200g, Savoury Ship's Olive Oil Crackers 220g, Van Roy Milk and Dark Chocolate Salted Caramel Truffles 85g, Jumbleberry Jam 225g"]]);
  PAGES = PAGES.concat([["Cheese, Duck Rillette & Wine Hamper", "https://www.artisandelimarket.co.uk/products/cheese-wine-pate-hamper-1", "£55 · Pictorial Cabernet Sauvignon, 75cl, Fig, Honey and Extra Virgin Olive Oil Crackers 125g, Duck Rillette with Cranberries & Grand Marnier 125g, Sticky Fig Chutney 225g, Garlic and Chive Cheddar Cheese 200g, Whole Camembert 250g"]]);
  PAGES = PAGES.concat([["Stilton & Sparkling", "https://www.artisandelimarket.co.uk/products/stilton-and-sparkling", "£150 · Henners Brut NV, 75cl, Potted Blue Stilton 100g, Walnut, Honey and Extra Virgin Olive Oil Crackers 125g, Boxing Day Chutney, Cranberry & Orange Mini Mince Pies 120g, Christmas Fudge Trio Slider 63g, Cocoa Loco Organic Milk Chocolate Santas 100g"]]);
  PAGES = PAGES.concat([["Gourmet Evening Hamper", "https://www.artisandelimarket.co.uk/products/gourmet-evening-hamper", "£110 · Fig, Honey and Extra Virgin Olive Oil Crackers 125g, Caramelised Onion Cheddar 200g, Just Jane Mature Cheese 200g, Wild Garlic Salami 60g, Air-dried Pork Loin Lomo 60g, Van Roy Dark Pink Champagne Truffles 75g, Clotted Cream Fudge Trio Slider 63g, Spicy Pitted Gordal Olives, Perello Cocktail Snack Mix 115g, Muriel Crianza Rioja, 75cl"]]);
  PAGES = PAGES.concat([["All the Trimmings", "https://www.artisandelimarket.co.uk/products/all-the-trimmings", "£195 · Gianduja Chocolate Bar with Torrone Pieces 260g, Panforte Fig & Walnut 100g, All-Butter Cracker Selection Box (Wheat, Spelt & Wholemeal) 375g, Cranberry Cheddar Cheese Barrel 145g, Caramelised Onion Cheddar 200g, Etico Extra Virgin Olive Oil 500ml, Condimento Balsamico, Pure Unblended 5 Year Old Balsamic 250ml, Mince Pie Stuffed Cookies 150g, Christmas Iced Fruit Cake in Tin, Mulled Wine Chutney"]]);
  PAGES = PAGES.concat([["Christmas Wine, Cheese and Treats Hamper", "https://www.artisandelimarket.co.uk/products/christmas-wine-cheese-and-treats-hamper", "£75 · La Gran Bestia Malbec 2021, 75cl, Cranberry Cheddar Cheese Barrel 145g, Picos Blue 100g, Cranberry, Sour Cherry & Extra Virgin Olive Oil Crackers 125g, Cranberry & Orange Mini Mince Pies 120g, Mulled Wine Chutney, Sticky Fig Chutney, Chocolate & Orange Shortbread Rounds 150g, Christmas Fudge Trio Slider 63g"]]);
  PAGES = PAGES.concat([["Christmas Savoury Goodies Hamper", "https://www.artisandelimarket.co.uk/products/christmas-savoury-goodies-hamper", "£65 · Cranberry Cheddar Cheese Barrel 145g, Caramelised Onion Cheddar 200g, Air-dried Pork Loin Lomo 60g, Cranberry, Sour Cherry & Extra Virgin Olive Oil Crackers 125g, Mulled Wine Chutney, Christmas Iced Fruit Cake in Tin, Chocolate & Orange Shortbread Rounds 150g, Christmas Fudge Trio Slider 63g"]]);
  PAGES = PAGES.concat([["The Fireside Hamper", "https://www.artisandelimarket.co.uk/products/the-fireside-hamper", "£90 · Pictorial Cabernet Sauvignon, 75cl, Potted Blue Stilton 100g, Cranberry, Sour Cherry & Extra Virgin Olive Oil Crackers 125g, Mulled Wine Chutney, Cranberry & Orange Mini Mince Pies 120g, Christmas Fudge Trio Slider 63g"]]);
  function renderRes(){
    if(!srchRes) return;
    var q = srchQ.value.trim().toLowerCase();
    if(q.length < 2){ srchRes.hidden = true; srchRes.innerHTML = ''; return; }
    var qEsc = esc(srchQ.value.trim());

    var pages = PAGES.filter(function(p){
      return (p[0] + ' ' + p[2]).toLowerCase().indexOf(q) > -1;
    }).slice(0, 4);

    var things = [];
    if(typeof LARDER !== 'undefined'){
      things = LARDER.filter(function(it){
        return (it.t + ' ' + (it.m || '') + ' ' + aisleOf(it.a)).toLowerCase().indexOf(q) > -1;
      }).slice(0, 6);
    }

    var html = '';
    if(things.length){
      html += '<div class="sr-grp"><span class="t-label">On the shelf</span>'
        + things.map(function(it){
            return '<a class="sr-row" href="' + U.create + '?q=' + encodeURIComponent(it.t) + '">'
              + '<span class="sr-t">' + esc(it.t) + '</span>'
              + '<span class="sr-m">' + esc([it.m, aisleOf(it.a)].filter(Boolean).join(' · ')) + '</span>'
              + '<span class="sr-p num">' + money(it.p) + '</span></a>';
          }).join('')
        + '</div>';
    }
    if(pages.length){
      html += '<div class="sr-grp"><span class="t-label">Pages</span>'
        + pages.map(function(p){
            return '<a class="sr-row" href="' + p[1] + '"><span class="sr-t">' + esc(p[0]) + '</span>'
              + '<span class="sr-m">' + esc(p[2]) + '</span></a>';
          }).join('')
        + '</div>';
    }
    /* zero results is a real state, not a blank panel: say so, then give the
       one move that still has 764 things and every hamper behind it */
    if(!html) html = '<p class="sr-none">Nothing on the shelf or on these pages is called “' + qEsc + '”.</p>';
    /* the list scrolls; the button does NOT live inside it. On a phone a long
       list otherwise buries the one move that searches everything. */
    srchRes.innerHTML = '<div class="sr-list">' + html + '</div>'
      + '<button type="submit" class="sr-go">Look through the hampers for “' + qEsc + '” <span aria-hidden="true">→</span></button>';
    srchRes.hidden = false;
  }
  srchQ.addEventListener('input', renderRes);

  /* the sheet's search field is a doorway to the same panel, never a dead end.

     It used to open that panel on `focus`, which conflates "I want to search"
     with "the cursor happens to be here". Tabbing down the menu landed on this
     field, and the field threw the menu away and teleported the keyboard user
     into a search overlay they never asked for — the sheet closed under them
     mid-list. It now waits for a real intent: a tap, Enter, or the first
     character actually typed. Tabbing past it does nothing at all.

     THE INTENT IS A `click`, NEVER A `pointerdown`. Moving off focus, the fix
     above first reached for pointerdown — and that took the search away from
     every phone on the site. A tap is pointerdown, then pointerup, then a
     click the browser hit-tests afresh; run the hand-off on pointerdown and the
     sheet holding the field is gone by the time that hit-test happens, so the
     tap's own click lands on whatever is now under the finger — the search
     overlay's backdrop, whose click handler closes it. Menu shut, search shut,
     one tap, and with the header magnifier display:none under 1060px there is
     no other way to search on a phone. `click` fires for mouse, touch and pen
     alike, and by the time it runs its target is already settled, so tearing
     the sheet down inside it is safe.

     Typing hands the letters over too. Anything else would eat the word: you
     type "cheese" here, the panel opens, and the box is empty. */
  var sheetSearchInput = sheet.querySelector('.sheet-search input');
  if(sheetSearchInput){
    var handingOver = false;
    var toSearch = function(e){
      if(e && e.cancelable) e.preventDefault();
      /* one gesture, one hand-off: a keystroke that also produces an `input`
         must not open the panel twice. Same task only — a second, deliberate
         tap a moment later is a real request and has to work. */
      if(handingOver) return;
      handingOver = true;
      setTimeout(function(){ handingOver = false; }, 0);
      var carried = sheetSearchInput.value;
      sheetSearchInput.value = '';
      sheetSearchInput.blur();
      setSheet(false, true);                        // quiet: the overlay takes focus
      if(carried) srchQ.value = carried;
      setSrch(true, burger);                        // Escape comes back to the burger
      /* setSrch focuses the field synchronously (focusIn), so the next
         character typed lands in it. It used to wait 60ms and "stilton" came
         out "silton". */
      if(carried) renderRes();
    };
    sheetSearchInput.addEventListener('click', toSearch);
    sheetSearchInput.addEventListener('input', toSearch);
    sheetSearchInput.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' ') toSearch(e);
    });
  }

  /* ---------- the Composer's door: carry on, or start another ----------
     Verity/Harry call 2026-09-29 (recall #3867). The Composer holds one
     composition per browser tab (sessionStorage 'adm-draft-20260907-create'). Every door into
     it (the hero and its name, the two ways in, "Create a hamper" in the
     header, the menu and search, the occasion landers, the season panels) used
     to walk straight in: a new name from the hero was written over the hamper
     already on the go, and there was no way to begin a second one without
     finishing or emptying the first.

     So a link to the Composer, while a hamper is part-way through, asks first:
     carry on with it, or start a new one. Starting a new one never throws the
     first away. It is set to one side (this tab, the eight most recent) and
     the same question offers it back, so nothing is lost without a click that
     says so. One delegated listener covers every door, including the ones on
     pages this file does not know about; a door that means "carry on" (the
     chip, the bar, a search result that finds a thing on the shelf) goes
     straight through. A native <dialog>: the browser makes the page behind it
     inert and handles Escape; this adds the Tab loop, the backdrop click, the
     X and the return of focus to the door that opened it. */
  var K = {create:'adm-draft-20260907-create', sum:'adm-draft-20260907-create-sum', edit:'adm-draft-20260907-edit-id', src:'adm-draft-20260907-edit-source'};
  K.aside = K.create + '-aside';    /* derived, so any rename of the key above carries it too */
  var ASIDE_MAX = 8;
  var VESSEL_NAME = {wicker:'The Wicker Basket', signature:'The Signature Box', presentation:'The Presentation Box'};
  function sGet(k){ try{ return sessionStorage.getItem(k); }catch(e){ return null; } }
  function sSet(k, v){
    try{ if(v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); return true; }
    catch(e){ return false; }
  }
  function parse(v){ try{ return JSON.parse(v || 'null'); }catch(e){ return null; } }
  function countOf(d){
    var n = 0;
    if(d && d.items) for(var t in d.items) if(Object.prototype.hasOwnProperty.call(d.items, t)) n += (d.items[t] && +d.items[t].q) || 0;
    return n;
  }
  /* work worth asking about: a thing in the box, a box chosen, words written,
     a card or a day picked. A name on its own is not; the door carries one. */
  function isWork(d){
    return !!(d && typeof d === 'object'
      && (countOf(d) || d.vessel || (d.msg && String(d.msg).trim()) || d.cardId || d.day));
  }
  function current(){
    var raw = sGet(K.create);
    return isWork(parse(raw)) ? {s:raw, sum:sGet(K.sum), edit:sGet(K.edit), src:sGet(K.src), at:Date.now()} : null;
  }
  function asides(){
    var a = parse(sGet(K.aside));
    return Array.isArray(a) ? a.filter(function(x){ return x && isWork(parse(x.s)); }) : [];
  }
  function saveAsides(a){ return sSet(K.aside, a.length ? JSON.stringify(a.slice(0, ASIDE_MAX)) : null); }
  function clearCurrent(){ sSet(K.create, null); sSet(K.sum, null); sSet(K.edit, null); sSet(K.src, null); }
  function putBack(x){ sSet(K.create, x.s); sSet(K.sum, x.sum); sSet(K.edit, x.edit); sSet(K.src, x.src); }
  function describe(x){
    var d = parse(x.s) || {}, sum = parse(x.sum) || {};
    var n = countOf(d), bits = [];
    if(d.vessel && VESSEL_NAME[d.vessel]) bits.push(VESSEL_NAME[d.vessel]);
    bits.push(n ? n + (n === 1 ? ' item' : ' items') : 'nothing in it yet');
    /* the total the Composer itself last wrote, and only while it still
       describes these same items: never a sum worked out here */
    if(n && sum && sum.n === n && typeof sum.total === 'number') bits.push(money(sum.total));
    return {name:d.name || '', whose:d.name ? possess(d.name) + ' hamper' : 'Your hamper', line:bits.join(' · '), edit:!!x.edit};
  }

  var createPath = (function(){ try{ return new URL(U.create, location.href).pathname.replace(/\/$/, ''); }catch(e){ return null; } })();
  function composerLink(a){
    if(!createPath || !a || !a.href) return null;
    if(a.closest('#ch-basket,#ch-basket-alt,#ch-basket-m,#ch-compbar,[data-compose-continue]')) return null;
    if(a.target && a.target !== '_self') return null;
    var u; try{ u = new URL(a.href, location.href); }catch(e){ return null; }
    if(u.origin !== location.origin || u.pathname.replace(/\/$/, '') !== createPath) return null;
    if(u.searchParams.get('q')) return null;          /* "find this on the shelf" means carry on */
    return u;
  }

  var door = null, doorFrom = null, doorTo = null, doorArmed = false;
  function doorEl(){
    if(door) return door;
    door = document.createElement('dialog');
    door.className = 'cdoor';
    door.id = 'ch-door';
    door.setAttribute('aria-labelledby', 'ch-door-h');
    door.setAttribute('aria-describedby', 'ch-door-now');
    door.innerHTML =
      '<div class="cdoor-in">'
    +   '<button type="button" class="cdoor-x" data-door="close" aria-label="Close, and stay on this page"><svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.6"/></svg></button>'
    +   '<p class="cdoor-k">Before you go on</p>'
    +   '<h2 class="cdoor-h" id="ch-door-h"></h2>'
    +   '<div class="cdoor-now" id="ch-door-now"><span class="cdoor-who"></span><span class="cdoor-line num"></span></div>'
    +   '<div class="cdoor-acts">'
    +     '<button type="button" class="btn cdoor-go" data-door="continue"></button>'
    +     '<button type="button" class="btn btn--ghost cdoor-new" data-door="new"></button>'
    +   '</div>'
    +   '<p class="cdoor-note" id="ch-door-note"></p>'
    +   '<div class="cdoor-aside" id="ch-door-aside"><h3 class="cdoor-ak">Set to one side</h3><ul class="cdoor-list"></ul></div>'
    + '</div>';
    document.body.appendChild(door);
    /* a modal <dialog> lets Tab walk out into the browser's own controls; the
       site's one trap keeps it going round the dialog instead */
    trapTab(door, function(){ return door.open; });
    door.addEventListener('click', function(e){
      if(e.target === door){ door.close(); return; }                   /* the backdrop */
      var b = e.target.closest('[data-door]'); if(!b) return;
      var act = b.getAttribute('data-door');
      if(act === 'close') door.close();
      else if(act === 'continue') goContinue();
      else if(act === 'new') goNew();
      else if(act === 'back') goBack(+b.getAttribute('data-i'));
      else if(act === 'drop') dropAside(+b.getAttribute('data-i'));
    });
    door.addEventListener('close', function(){
      document.body.style.overflow = '';
      var back = doorFrom; doorFrom = null;
      if(back && back.isConnected && back.getClientRects().length) back.focus();
    });
    return door;
  }
  function wantedName(){ return doorTo ? (doorTo.searchParams.get('for') || '').trim().slice(0, 24) : ''; }
  function paintDoor(){
    var now = current(), list = asides(), want = wantedName();
    var h = door.querySelector('.cdoor-h'), nowBox = door.querySelector('.cdoor-now');
    var go = door.querySelector('.cdoor-go'), fresh = door.querySelector('.cdoor-new');
    var note = door.querySelector('.cdoor-note'), asideBox = door.querySelector('.cdoor-aside');
    doorArmed = false;
    fresh.textContent = want ? 'Start ' + possess(want) + ' hamper' : 'Start a new hamper';
    if(now){
      var d = describe(now);
      h.textContent = d.edit ? 'You’re part-way through changing ' + d.whose.replace(/^Your/, 'your')
                             : (d.name ? 'You’re part-way through ' + d.whose : 'You’re part-way through a hamper');
      nowBox.hidden = false;
      nowBox.querySelector('.cdoor-who').textContent = d.whose;
      nowBox.querySelector('.cdoor-line').textContent = d.line;
      go.hidden = false;
      go.textContent = 'Continue ' + (d.name ? d.whose : 'this hamper');
      note.textContent = (d.name ? possess(d.name) : 'This one') + ' stays saved: set to one side in this browser tab, ready to come back to from here.';
      fresh.classList.add('btn--ghost');
    } else {
      h.textContent = list.length === 1 ? 'You set ' + describe(list[0]).whose.replace(/^Your/, 'a') + ' to one side' : 'You set some hampers to one side';
      nowBox.hidden = true;
      go.hidden = true;
      note.textContent = '';
      fresh.classList.remove('btn--ghost');
    }
    note.hidden = !note.textContent;
    asideBox.hidden = !list.length;
    asideBox.querySelector('.cdoor-ak').hidden = !now;
    door.querySelector('.cdoor-list').innerHTML = list.map(function(x, i){
      var a = describe(x);
      return '<li class="cdoor-row"><span class="cdoor-rt"><span class="cdoor-who">' + esc(a.whose) + '</span><span class="cdoor-line num">' + esc(a.line) + '</span></span>'
        + '<button type="button" class="cdoor-back" data-door="back" data-i="' + i + '">Go back to ' + esc(a.name ? possess(a.name) : 'this one') + '<span aria-hidden="true"> →</span></button>'
        + '<button type="button" class="cdoor-drop" data-door="drop" data-i="' + i + '" aria-label="Remove ' + esc(a.whose) + ' for good">Remove</button></li>';
    }).join('');
  }
  function goContinue(){
    var d = parse(sGet(K.create)) || {}, want = wantedName();
    /* the name typed at the door only lands on a hamper that has none yet */
    location.href = U.create + (!d.name && want ? '?for=' + encodeURIComponent(want) : '');
  }
  function goNew(){
    var now = current();
    if(now){
      var list = asides(); list.unshift(now);
      if(!saveAsides(list) && !doorArmed){
        /* storage refused: say so, and let a second, deliberate press go on */
        doorArmed = true;
        var note = door.querySelector('.cdoor-note');
        note.hidden = false;
        note.textContent = 'This browser won’t let us keep ' + describe(now).whose.replace(/^Your/, 'your') + ' to one side. Press Start again and it will be lost.';
        return;
      }
    }
    clearCurrent();
    location.href = doorTo ? doorTo.href : U.create;
  }
  function goBack(i){
    var list = asides(), x = list[i]; if(!x) return;
    list.splice(i, 1);
    var now = current(); if(now) list.unshift(now);
    if(!saveAsides(list)) return;
    putBack(x);
    location.href = U.create;
  }
  function dropAside(i){
    var list = asides(); list.splice(i, 1); saveAsides(list);
    if(!current() && !list.length){ door.close(); return; }
    paintDoor();
    var f = door.querySelector('.cdoor-back') || door.querySelector('.cdoor-new');
    if(f) f.focus();
  }
  function openDoor(u, opener){
    if(!window.HTMLDialogElement || !current() && !asides().length) return false;
    doorEl();
    if(!door.showModal) return false;
    doorTo = u;
    if(sheet && sheet.classList.contains('open')){ setSheet(false); opener = burger; }
    if(srch && srch.classList.contains('open')){ setSrch(false); opener = document.activeElement; }
    if(occOpen) setOcc(false);
    doorFrom = opener || document.activeElement;
    paintDoor();
    document.body.style.overflow = 'hidden';
    door.showModal();
    var first = door.querySelector('.cdoor-go:not([hidden])') || door.querySelector('.cdoor-new');
    if(first) first.focus();
    return true;
  }
  document.addEventListener('click', function(e){
    if(e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    var u = composerLink(a);
    if(u && openDoor(u, a)) e.preventDefault();
  });
  /* back from the Composer (bfcache): never find the question still standing */
  addEventListener('pagehide', function(){ if(door && door.open) door.close(); });

  /* ---------- the chip: the same truth on every page ---------- */
  function labelFor(sum){ return sum && sum.name ? possess(sum.name) + ' hamper' : null; }
  function paintChip(){
    var create = read('adm-draft-20260907-create-sum');       // {n:items, total, name} — composing now
    var basket = read('adm-draft-20260907-basket-sum');        // {n:gifts, total, name}  — committed
    var chip = document.getElementById('ch-basket');
    var chipM = document.getElementById('ch-basket-m');
    var chipAlt = document.getElementById('ch-basket-alt');
    var compbar = document.getElementById('ch-compbar');
    var compL = document.getElementById('ch-compbar-l');
    var compGo = document.getElementById('ch-compbar-go');
    function setPlain(el){ if(el){ el.className = el.id==='ch-basket-m' ? 'hbasket hbasket-m' : 'hbasket'; el.innerHTML='<span class="hb-ico">'+ICON_BASKET+'</span>'; el.setAttribute('href', U.basket); el.setAttribute('aria-label','Basket');
      if(el.id==='ch-basket-m' && basket && basket.n>0){
        el.innerHTML += '<span class="mobile-basket-count" aria-hidden="true">'+basket.n+'</span>';
        el.setAttribute('aria-label','Basket, '+basket.n+(basket.n===1?' hamper':' hampers'));
      }
    } }
    document.body.classList.remove('has-compbar');
    if(compbar) compbar.classList.remove('on');
    /* the standing basket link is hidden by default and only earns its place
       when the chip beside it has been taken over by a composition */
    if(chipAlt) chipAlt.classList.remove('on');

    /* `note` carries a begun-but-empty composition — the homepage's Box movement
       sets it the moment a vessel is chosen, so the chip reads "Dad's hamper ·
       the wicker" before a single item exists. Without it the first, most
       fragile commitment a customer makes would leave no trace in the chrome. */
    if(create && (create.n > 0 || create.note)){
      var nm = labelFor(create) || 'Your hamper';
      var st = create.n > 0
        ? create.n + (create.n===1?' item':' items') + ' · ' + money(create.total)
        : create.note;
      if(chip){ chip.className='hbasket chip'; chip.setAttribute('href', U.create);
        chip.innerHTML = '<span class="hb-txt"><span class="hb-name">'+esc(nm)+'</span><span class="hb-state">'+st+'</span></span><span class="hb-go">Continue</span>';
        chip.setAttribute('aria-label', nm + ', ' + st + ' — continue composing'); }
      setPlain(chipM);
      /* the composing chip points at /create/, so on desktop the basket has
         nowhere else to be reached from — unless it is empty, in which case
         there is nothing to reach. Show it exactly when there is. */
      if(chipAlt && basket && basket.n > 0){
        chipAlt.classList.add('on');
        chipAlt.querySelector('.hb-n').textContent = basket.n;
        chipAlt.setAttribute('aria-label', 'Basket, ' + basket.n + (basket.n===1?' hamper, ':' hampers, ') + money(basket.total));
      }
      if(compbar){ compbar.setAttribute('href', U.create); compbar.classList.add('on'); document.body.classList.add('has-compbar');
        compL.innerHTML = '<em>'+esc(nm)+'</em><span class="cb-st num">'+st+'</span>'; compGo.textContent='Continue →'; }
      return;
    }
    if(basket && basket.n > 0){
      var isOne = basket.n===1;
      var nm2 = isOne ? (labelFor(basket) || 'Your hamper') : (basket.n + ' hampers');
      if(chip){ chip.className='hbasket chip'; chip.setAttribute('href', U.basket);
        chip.innerHTML = '<span class="hb-txt"><span class="hb-name">'+esc(nm2)+'</span><span class="hb-state">'+money(basket.total)+'</span></span>';
        chip.setAttribute('aria-label', nm2 + ', ' + money(basket.total) + ' — view basket'); }
      setPlain(chipM);
      if(compbar){ compbar.setAttribute('href', U.basket); compbar.classList.add('on'); document.body.classList.add('has-compbar');
        compL.innerHTML = '<em>'+esc(nm2)+'</em><span class="cb-st num">· '+money(basket.total)+'</span>'; compGo.textContent='The basket →'; }
      return;
    }
    setPlain(chip); setPlain(chipM);
  }
  paintChip();
  addEventListener('storage', paintChip);
  addEventListener('pageshow', paintChip);           // back/forward cache
  window.ADMChrome = { paintChip: paintChip };
})();
